import {
  DatahubEntity,
  IDefaultSchema,
  IFullscreenSchema,
  FullscreenAction,
  DATA_VERSION,
  CaptureEventData,
  FullscreenStatus,
  CaptureEvent,
} from 'src/interfaces/Datahub';

import AplicationService from 'src/services/ApplicationService';
import { isFullscreen } from 'src/utils/browserUtils';

class Fullscreen {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  change(captureEvent: CaptureEvent<FullscreenAction>) {
    const currentTime = AplicationService.player?.currentTime || 0;
    const isFullscreenEnabled = isFullscreen();

    const event: IFullscreenSchema = {
      ...this.defaultData,
      status: isFullscreenEnabled ? FullscreenStatus.ENABLED : FullscreenStatus.DISABLED,
      time: Math.floor(currentTime),
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    captureEvent(DatahubEntity.FULLSCREEN, FullscreenAction.CHANGE, data);
  }
}

export default Fullscreen;
